<template>
	<div class="citylist-dialog">
		<el-dialog
		  title=""
		  :lock-scroll="true"
		  :visible.sync="dialogVisible"
		  @close="$parent.cityDialogshow = false"
		  :close-on-click-modal="false"
		  :close-on-press-escape="false"
		  width="500px">
		  <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="城市名称:">
          <el-input v-model="form.csmc" placeholder="请输入城市名称" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="城市编码:">
          <el-input v-model="form.csbm" placeholder="请输入城市编码" maxlength="20" show-word-limit></el-input>
        </el-form-item>
		  </el-form>
		  <span slot="footer" class="dialog-footer">
			<el-button @click="$parent.cityDialogshow = false">关 闭</el-button>
			<el-button type="primary" @click="citySave">确 定</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
export default {
  name: "CityDialog",
  data() {
	return {
		dialogVisible: true,
		fcsid:this.$parent.csid,	//id
		form: {
			csid:'',	//城市id
			csmc:'',	//城市名称
			csbm:'',	//城市编码
		}
	}
  },
  mounted: function () {
  },
  methods: {
    citySave(){//保存指标项
      var city = {
        id:this.form.csid,
        csmc:this.form.csmc,
        csbm:this.form.csbm,
        fcsid:this.fcsid,
      }
      this.$post("admin/CityController/citySave",city,'json').then(response => {
        if(response.code == '1'){
          this.$message({
            message: response.msg,
            type: 'success'
          });
          this.$parent.cityDialogshow = false;
          this.$parent.treeList();
        }else{
          this.$message({
            message: response.msg,
            type: 'error'
          });
        }
      })
    }
  }
}
</script>

<style lang="less">
	.citylist-dialog{
		.el-form-item__content{
			text-align: left;
		}
	}
</style>
